import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { staticPath } from '~/lib/$path'

export const IntroStep: FC = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, px: 4 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', width: '50%', lineHeight: '1.8' }}>
        Instagram連携をすることで、Instagramから取得できるデータを利用したさまざまな機能をご利用いただけます。
      </Typography>
      <img
        style={{ display: 'block', objectFit: 'cover', width: '50%' }}
        src={staticPath.facebook_connect_steps.intro_png}
        alt=""
      />
    </Box>
  )
}
